import { BranchLinkOptions } from '../branchLinkConfiguration';
import { enrichBranchLinkOptions } from './utilities';
import { generateBranchShortLink } from './short-link-generator';
import { generateBranchLongLink } from './long-link-generator';

export const createLink = (branchLinkOptions: BranchLinkOptions): Promise<string> => {
  const enrichedBranchLinkOptions = enrichBranchLinkOptions(branchLinkOptions);
  return generateBranchShortLink(enrichedBranchLinkOptions);
};

export const createLinkSync = (branchLinkOptions: BranchLinkOptions): string => {
  const enrichedBranchLinkOptions = enrichBranchLinkOptions(branchLinkOptions);
  return generateBranchLongLink(enrichedBranchLinkOptions);
};
